import { useQuery } from '@tanstack/react-query';

import { CugTier, getGHAChains } from '~/services/ConnectionGoogleService';

export const ghaChainQueryKeys = {
  all: ['ghaChains'] as const,
  // Sorted so ['tier_3','tier_4'] and ['tier_4','tier_3'] share one cache entry.
  list: (cugTiers: Array<CugTier>) => [...ghaChainQueryKeys.all, [...cugTiers].sort()] as const,
};

/**
 * Chain options for the property filter typeahead.
 *
 * The whole list is fetched once per tier combination and filtered client-side, so typing costs no
 * requests. `staleTime` keeps toggling the tier filter back and forth from refetching.
 */
export function useGHAChains(cugTiers: Array<CugTier> = []) {
  return useQuery({
    queryKey: ghaChainQueryKeys.list(cugTiers),
    queryFn: () => getGHAChains(cugTiers.length > 0 ? cugTiers : undefined),
    staleTime: 5 * 60 * 1000,
  });
}
